module.exports = __webpack_public_path__ + "img/identidade-frente-sample.7d47eb85.png";